// extracted by mini-css-extract-plugin
module.exports = {"videoDetail":"VideoDetail_videoDetail__3Egai","videoDeatil_video":"VideoDetail_videoDeatil_video__2wYTG","react_player":"VideoDetail_react_player__2CMLi"};